import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaBell,
  FaCalendarAlt,
  FaUserGraduate,
  FaChalkboardTeacher,
  FaClipboardCheck,
  FaUsers,
  FaBullhorn
} from "react-icons/fa";

export default function Dashboard() {

  const role = sessionStorage.getItem("role");
  const navigate = useNavigate();
  const [showHolidayModal, setShowHolidayModal] = useState(false);

  const holidays = [
    { id: 1, holidayName: "Republic Day", holidayDate: "2026-01-26" },
    { id: 2, holidayName: "Maha Shivaratri", holidayDate: "2026-02-14" },
    { id: 3, holidayName: "Ugadi", holidayDate: "2026-03-29" },
    { id: 4, holidayName: "Sri Rama Navami", holidayDate: "2026-04-27" },
    { id: 5, holidayName: "Bakrid", holidayDate: "2026-05-27" },
    { id: 6, holidayName: "Bonalu", holidayDate: "2026-08-10" },
    { id: 7, holidayName: "Vinayaka Chavithi", holidayDate: "2026-09-14" },
    { id: 8, holidayName: "Gandhi Jayanti", holidayDate: "2026-10-02" },
    { id: 9, holidayName: "Dasara", holidayDate: "2026-10-20" },
    { id: 10, holidayName: "Christmas", holidayDate: "2026-12-25" }
  ];

  const announcements = [
    {
      id: 1,
      title: "Mid-Term Exams Start Next Week",
      date: "2026-03-05",
      type: "New"
    },
    {
      id: 2,
      title: "Parent-Teacher Meeting on Friday",
      date: "2026-03-10",
      type: "Important"
    }
  ];

  const notifications = [
    "Attendance marked for Class 10-A",
    "New user registered: teacher2",
    "Fee payment received from Rahul"
  ];

  const quickLinksAdmin = [
    { name: "Add/Update Student", icon: <FaUserGraduate />, route: "/dashboard/students" },
    { name: "Add/Update Staff", icon: <FaChalkboardTeacher />, route: "/dashboard/staff" },
    { name: "Mark Attendance", icon: <FaClipboardCheck />, route: "/dashboard/markattendance" },
    { name: "Announcements", icon: <FaBullhorn />, route: "/dashboard/announcements" }
  ];

  const quickLinksTeacher = [
    { name: "Mark Attendance", icon: <FaClipboardCheck />, route: "/teacher/markattendance" },
    { name: "My Students", icon: <FaUsers />, route: "/teacher/students" },
    { name: "Announcements", icon: <FaBullhorn />, route: "/teacher/announcements" }
  ];

  const quickLinks = role === "ADMIN" ? quickLinksAdmin : quickLinksTeacher;

  return (
    <div className="space-y-6 w-full max-w-full overflow-hidden">

      {/* UPCOMING HOLIDAYS */}

      <div className="bg-white rounded-xl shadow p-4">

        <div className="flex justify-between items-center mb-3">

          <h2 className="text-lg font-semibold flex items-center gap-2">
            <FaCalendarAlt className="text-blue-600" />
            Upcoming Holidays
          </h2>

          <button
            onClick={() => setShowHolidayModal(true)}
            className="text-sm text-blue-600 hover:underline"
          >
            View All
          </button>

        </div>

        {/* Horizontal scroll container */}

        <div className="flex gap-4 overflow-x-auto pb-2 w-full max-w-full">

          {holidays.map((h, index) => (

            <div
              key={h.id}
              className={`min-w-[180px] flex-shrink-0 p-3 rounded-lg border
              ${index === 0
                ? "bg-green-50 border-green-200"
                : "bg-blue-50 border-blue-100"
              }`}
            >

              <p className="text-xs text-gray-500">
                {new Date(h.holidayDate).toLocaleDateString("en-US", {
                  weekday: "short",
                  month: "short",
                  day: "2-digit"
                })}
              </p>

              <p className="font-semibold text-sm">
                {h.holidayName}
              </p>

              {index === 0 && (
                <span className="text-xs text-green-700">
                  Next Holiday
                </span>
              )}

            </div>

          ))}

        </div>

      </div>


      {/* STATS */}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full">

        {role === "ADMIN" && (
          <>
            <div className="bg-blue-50 p-6 rounded-xl shadow">
              <h3 className="text-gray-500 text-sm">Total Students</h3>
              <p className="text-3xl font-bold">250</p>
            </div>

            <div className="bg-purple-50 p-6 rounded-xl shadow">
              <h3 className="text-gray-500 text-sm">Total Teachers</h3>
              <p className="text-3xl font-bold">25</p>
            </div>
          </>
        )}

        <div className="bg-green-50 p-6 rounded-xl shadow">
          <h3 className="text-gray-500 text-sm">Attendance %</h3>
          <p className="text-3xl font-bold text-green-600">92%</p>
        </div>

      </div>


      {/* QUICK LINKS */}

      <div className="bg-white rounded-xl shadow p-5">

        <h3 className="text-lg font-semibold mb-3">
          ⚡ Quick Links
        </h3>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 w-full">

          {quickLinks.map((link, index) => (

            <div
              key={index}
              onClick={() => navigate(link.route)}
              className="flex flex-col items-center justify-center p-4 border rounded-lg hover:bg-gray-50 cursor-pointer transition"
            >

              <div className="text-xl text-blue-600 mb-2">
                {link.icon}
              </div>

              <p className="text-sm font-medium text-center">
                {link.name}
              </p>

            </div>

          ))}

        </div>

      </div>


      {/* ANNOUNCEMENTS + NOTIFICATIONS */}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

        {/* ANNOUNCEMENTS */}

        <div className="bg-white p-5 rounded-xl shadow">

          <h3 className="text-lg font-bold mb-4">
            📢 Announcements
          </h3>

          <div className="space-y-3">

            {announcements.map((item) => (

              <div key={item.id} className="border-b pb-2">

                <div className="flex justify-between items-center">

                  <p className="font-semibold text-sm">
                    {item.title}
                  </p>

                  <span
                    className={`text-xs px-2 py-1 rounded
                    ${item.type === "New"
                      ? "bg-green-100 text-green-700"
                      : "bg-yellow-100 text-yellow-700"
                    }`}
                  >
                    {item.type}
                  </span>

                </div>

                <p className="text-xs text-gray-500">
                  {item.date}
                </p>

              </div>

            ))}

          </div>

        </div>


        {/* NOTIFICATIONS */}

        <div className="bg-white p-5 rounded-xl shadow">

          <h3 className="text-lg font-bold mb-4 flex items-center gap-2">
            <FaBell className="text-blue-600" />
            Notifications
          </h3>

          <ul className="space-y-2">

            {notifications.map((note, index) => (

              <li
                key={index}
                className="text-sm border-b pb-1"
              >
                {note}
              </li>

            ))}

          </ul>

        </div>

      </div>


      {/* HOLIDAY MODAL */}

      {showHolidayModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-4">

          <div className="bg-white rounded-xl shadow-lg w-full max-w-lg max-h-[80vh] overflow-y-auto p-6">

            <div className="flex justify-between mb-4">

              <h2 className="text-lg font-semibold">
                Holidays - Academic Year
              </h2>

              <button
                onClick={() => setShowHolidayModal(false)}
                className="text-gray-500 hover:text-black"
              >
                ✕
              </button>

            </div>

            <div className="space-y-2">

              {holidays.map((h) => (

                <div
                  key={h.id}
                  className="flex justify-between border-b pb-2"
                >

                  <span>{h.holidayName}</span>

                  <span className="text-gray-500 text-sm">
                    {new Date(h.holidayDate).toLocaleDateString("en-US", {
                      month: "short",
                      day: "2-digit"
                    })}
                  </span>

                </div>

              ))}

            </div>

          </div>

        </div>
      )}

    </div>
  );
}